export class CustomLoading {
  loading;
  Loading;

  constructor(loading) {
      this.Loading = loading;
  }

  showLoading() {
    this.hideLoading();
      this.loading = this.Loading.service({
          // target: ".main-body-wrap",
          target: "body",
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.5)'
      });
  }

  hideLoading() {
      if(this.loading?.close) {
        this.loading.close();
        this.loading = null;
      }
  }
}

